export var breakpoints = {
    mobile: '320px',
    tablet: '600px',
    laptop: '1024px',
    desktop: '1600px',
};
